// modifer: styles/jss/nextjs-material-kit-pro/pages/aboutUsStyle.js
import { main } from 'styles/jss/original/base';

const styles = {
  main
};

export default styles;
